<template>
  <div id="main-content" class="detail-student">
    <el-col :offset="1" :span="22">
      <PageTitle :title="title" :backLink="backLink"></PageTitle>
      <el-row>
        <el-form :inline="true" class="demo-form-inline">
          <el-form-item>
            <el-button type="success" @click="goToEdit()">{{ $t('common.edit') }}</el-button>
          </el-form-item>
        </el-form>
      </el-row>
      <form v-if="adminInfo">
        <el-row>
          <el-col :span="11" style="display: inline">
            <span class="form-lable">{{ $t('common.full_name') }}:</span>
            <span class="info-span"> {{ adminInfo.fullname }} </span>
          </el-col>
          <el-col :offset="1" :span="12" style="display: inline">
            <span class="form-lable">{{ $t('common.display_name') }}:</span>
            <span class="info-span"> {{ adminInfo.display_name }} </span>
          </el-col>
        </el-row>
        <el-row style="padding-top: 20px">
          <el-col :span="11" style="display: inline">
            <span class="form-lable">{{ $t('common.furigana') }}:</span>
            <span class="info-span"> {{ adminInfo.furigana }} </span>
          </el-col>
          <el-col :offset="1" :span="12" style="display: inline">
            <span class="form-lable">{{ $t('common.romaji') }}:</span>
            <span class="info-span"> {{ adminInfo.romaji }} </span>
          </el-col>
        </el-row>
        <el-row style="padding-top: 20px">
          <el-col :span="11" style="display: inline">
            <span class="form-lable">{{ $t('common.gender') }}:</span>
            <span class="info-span" v-if="adminInfo.gender">Male</span>
            <span class="info-span" v-else>Female</span>
          </el-col>
          <el-col :offset="1" :span="12" style="display: inline">
            <span class="form-lable" >{{ $t('common.email') }}</span>
            <span class="info-span"> {{ adminInfo.email }} </span>
          </el-col>
        </el-row>
        <el-row style="padding-top: 20px">
          <el-col :span="11" style="display: inline">
            <span class="form-lable">{{ $t('common.phone') }}:</span>
            <span class="info-span"> {{ adminInfo.phone }} </span>
          </el-col>
          <el-col :offset="1" :span="12" style="display: inline;">
            <span class="form-lable">{{ $t('admin.role') }}:</span>
            <span class="info-span"> {{ adminInfo.position }} </span>
          </el-col>
        </el-row>
      </form>
    </el-col>
  </div>
</template>

<script>
  import {mapState} from 'vuex'
  import PageTitle from '@/components/PageTitle'

  export default {
    name: "DetailAdmin",
    components: {
      PageTitle
    },
    data: function () {
      return {
        title: 'admin.admin_information',
        backLink: `/admin`
      }
    },
    mounted: function () {
      let successCallback = () => {
      };
      let payload = {
        successCallback,
        admin_id: this.$route.query.aid
      }
      this.$store.dispatch('admin/getAdminInfo', payload)
    },
    computed: {
      ...mapState('admin', ['adminInfo']),
    },
    methods: {
      goToEdit: function () {
        this.$router.push({path: '/admin/edit', query: { aid: this.$route.query.aid }});
      }
    }
  }
</script>

<style lang="scss">
  .day-in-week {
    width: 100%;
    float: left;
    text-align: left;
    font-weight: bold;
  }
  .detail-student .info-span {
    width: 40%;
    text-align: left;
  }
  .day-in-week {
    width: 100%;
    float: left;
    text-align: left;
    font-weight: bold;
  }
</style>